module.exports = __webpack_public_path__ + "img/owner1.d1f90161.jpg";